module.exports = __webpack_public_path__ + "resources/images/screen4-915cc6723422a3ab3ec8173261c25359-cache.png";